module.exports = __webpack_public_path__ + "img/1.8b994d84.jpg";